<template>
  <div>
    <AppEditPDFTemplatesDialog></AppEditPDFTemplatesDialog>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      class="elevation-1"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.form_name }}</td>
        <td>{{ props.item.body }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteElement(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
        </td>
      </template>
    </v-data-table>
    <AddPDFTemplateButton/>
  </div>
</template>

<script>
  import AddPDFTemplateButton from '@/components/buttons/AddPDFTemplateButton'
  import AppEditPDFTemplatesDialog from '@/components/dialogs/AppEditPDFTemplatesDialog'
  import resourcesMixins from '@/mixins/Resources'
  import formsAPI from '@/api/resources/forms'
  import Vue from 'vue'

  export default {
    name: 'PDFTemplates',
    components: { AddPDFTemplateButton, AppEditPDFTemplatesDialog },
    mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'templates',
        items: [],
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Form', value: 'form_name' },
          { text: 'Body', value: 'body' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Updated at', value: 'updated_at' },
          { text: 'Actions', value: 'actions' }
        ]
      }
    },
    methods: {
      loadListingSuccess (result) {
        result.forEach((item, i) => {
          formsAPI.loadForm(item.forms_id).then(result => {
            let formName = JSON.parse(result.form_structure).form_name

            Vue.set(item, 'form_name', formName)
          })
        })

        this.items = result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PDFTemplates.vue?6d1e3234